<template>
  <div class="floating-titles" :style="floatingBarStyle">
    <div class="mx-auto w-full">
      <div class="">
        <div>
          <ul class="footer-links flex-row">
            <li class="mx-0">
              <a
                href="#"
                :class="footer_btn_class"
                @click="on_footer_popup_click($event, 'left')"
                >Futibatinib Mechanism of Action</a
              >
            </li>
            <li class="mx-0 center-link">
              <a
                href="#"
                :class="footer_btn_class"
                @click="on_footer_popup_click($event, 'middle')"
                >Corporate Philosophy</a
              >
            </li>
            <li class="mx-0">
              <a
                href="#"
                :class="footer_btn_class"
                @click="on_footer_popup_click($event, 'right')"
                >Pipeline Overview</a
              >
            </li>

            <
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState, mapGetters } from "vuex";
export default {
  name: "FloatingTitles",
  props: ["barWidth", "barTop", "barFontSize"],
  computed: {
    ...mapState(["app_state", "page_state"]),
    floatingBarStyle() {
      return {
        width: this.barWidth,
        top: this.barTop,
        fontSize: Math.min(Math.max(this.barFontSize, 7), 13) + "px"
      };
    },
    can_show_menu() {
      return (
        (this.$store.state.app_state == 0 &&
          this.$store.state.page_state != 2) ||
        this.$store.state.app_state != 0
      );
    },
    footer_btn_class() {
      let str = "rounded inline-block px-3 py-0 rounded text-white ";

      str += "hover:text-gray-300";

      return str;
    }
  },
  methods: {
    on_footer_popup_click(e, link) {
      this.$bus.$emit("on-section-anim-ended", {
        id: "0",
        subid: link
      });
    }
  }
};
</script>
<style scoped>
.floating-titles {
  margin-top: 0;
  padding: 0;
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
}
.footer-links {
  height: 100%;
  display: flex;
  align-self: center;
  align-items: flex-start;
  margin-top: auto;
  justify-content: center;
  font-weight: bold;
}
.footer-links li {
  margin: 0;
  min-width: 28%;
  max-width: 28%;
  margin: 0;
  text-shadow: 0px 2px 2px rgba(0, 0, 0, 0.3);
  position: relative;
}
.footer-links a {
  color: #ffd6cd;
}
.footer-links a {
  transform: translateY(-70%);
}
.footer-links .center-link a {
  transform: translateY(0);
}
</style>



// WEBPACK FOOTER //
// src/components/FloatingTitles.vue